export default function ActionsFooter({
  onMoodClick,
  onSkinClick,
  onFeedbackClick,
  onHelpClick,
  onStudioClick,
  studioUrl = null,
  activeSheet = null,
  hiddenActions = [],
}) {
  const shows = (kind) => !hiddenActions.includes(kind);
  const linkClass = (kind) =>
    activeSheet === kind ? "actions__link--active" : undefined;

  return (
    <div className="actions">
      <div className="actions__list">
        {shows("mood") && (
          <a
            href="#!"
            className={linkClass("mood")}
            aria-current={activeSheet === "mood" ? "true" : undefined}
            onClick={(event) => {
              event.preventDefault();
              onMoodClick?.();
            }}
          >
            Moods
          </a>
        )}
        {shows("skin") && (
          <a
            href="#!"
            className={linkClass("skin")}
            aria-current={activeSheet === "skin" ? "true" : undefined}
            onClick={(event) => {
              event.preventDefault();
              onSkinClick?.();
            }}
          >
            Skins
          </a>
        )}
        {shows("help") && (
          <a
            href="#!"
            className={linkClass("help")}
            aria-current={activeSheet === "help" ? "true" : undefined}
            onClick={(event) => {
              event.preventDefault();
              onHelpClick?.();
            }}
          >
            Advanced
          </a>
        )}
        {shows("feedback") && (
          <a
            href="#!"
            className={linkClass("feedback")}
            aria-current={activeSheet === "feedback" ? "true" : undefined}
            onClick={(event) => {
              event.preventDefault();
              onFeedbackClick?.();
            }}
          >
            Feedback
          </a>
        )}
        {shows("studio") && studioUrl && (
          <a
            href="#!"
            className={linkClass("studio")}
            aria-current={activeSheet === "studio" ? "true" : undefined}
            title="Your slowed + reverb player, for your own songs"
            onClick={(event) => {
              event.preventDefault();
              onStudioClick?.();
            }}
          >
            Studio
          </a>
        )}
      </div>
    </div>
  );
}
